/* ============================================================
   YUKON COSMETICS - FIRST 100 PRE-ORDER FREE GIFT
   ============================================================

   WHAT THIS SCRIPT DOES:

   1. Checks whether the cart contains at least one of the
      9 Yukon Keratin Hair Fibre products.

   2. If yes:
      Automatically adds ONE FREE Hair Fibre Spray Applicator.

   3. If several Hair Fibres are purchased:
      Customer still receives only ONE free applicator.

   4. If all qualifying Hair Fibres are removed:
      The free applicator is automatically removed.

   5. If the free applicator is somehow added without a
      Hair Fibre:
      It will automatically be removed.

   6. Uses Shopify's Ajax Cart API and Sleek's native
      cart:refresh event.

   FREE GIFT VARIANT:
   57801069691222

   IMPORTANT:
   The free applicator product should have:
   - Price: £0
   - Available inventory: 100
   - Continue selling when out of stock: OFF
   - Product status: Active
   - Online Store channel: Published
   - Search/store visibility: Unlisted
   ============================================================ */

(function () {
  'use strict';


  /* ==========================================================
     SETTINGS
  ========================================================== */

  /* FREE Hair Fibre Spray Applicator variant ID */
  const FREE_GIFT_VARIANT_ID = 55116602704214;


  /* All Hair Fibre products that qualify for the free gift */
  const QUALIFYING_PRODUCT_HANDLES = new Set([
    'keratin-hair-fibres-black',
    'keratin-hair-fibres-dark-brown',
    'keratin-hair-fibres-medium-brown',
    'keratin-hair-fibres-light-brown',
    'keratin-hair-fibres-blonde',
    'keratin-hair-fibres-medium-blonde',
    'keratin-hair-fibres-auburn',
    'keratin-hair-fibres-grey',
    'keratin-hair-fibres-white'
  ]);


  /* Shopify locale-aware root URL */
  const SHOP_ROOT =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';


  /*
   * Prevent simultaneous checks from fighting
   * with each other.
   */
  let syncInProgress = false;
  let syncAgainAfterwards = false;



  /* ==========================================================
     GET CURRENT SHOPIFY CART
  ========================================================== */

  async function getCart() {
    const response = await fetch(
      SHOP_ROOT + 'cart.js',
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Yukon free gift: Could not retrieve cart.'
      );
    }

    return response.json();
  }



  /* ==========================================================
     CHECK FOR QUALIFYING HAIR FIBRES
  ========================================================== */

  function cartContainsHairFibres(cart) {
    return cart.items.some(function (item) {

      return QUALIFYING_PRODUCT_HANDLES.has(
        item.handle
      );

    });
  }



  /* ==========================================================
     FIND FREE GIFT LINES IN CART
  ========================================================== */

  function getFreeGiftLines(cart) {
    return cart.items.filter(function (item) {

      return Number(item.variant_id) ===
        FREE_GIFT_VARIANT_ID;

    });
  }



  /* ==========================================================
     ADD FREE APPLICATOR
  ========================================================== */

  async function addFreeGift() {

    const response = await fetch(
      SHOP_ROOT + 'cart/add.js',
      {
        method: 'POST',
        credentials: 'same-origin',

        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: FREE_GIFT_VARIANT_ID,
              quantity: 1,

              /*
               * Private line-item property.
               *
               * The underscore means Shopify does not need
               * to display this property to the customer,
               * but it can help identify why the product
               * was included on the order.
               */
              properties: {
                _yukon_free_gift:
                  'First 100 pre-orders'
              }
            }
          ]
        })
      }
    );


    /*
     * If all 100 promotional applicators have already
     * been sold, Shopify should reject the add request.
     *
     * We simply stop adding gifts rather than breaking
     * the customer's cart.
     */
    if (!response.ok) {

      let errorData = null;

      try {
        errorData = await response.json();
      } catch (error) {
        /* No JSON response available */
      }


      console.warn(
        'Yukon free gift could not be added.',
        errorData || response.status
      );

      return false;
    }


    return true;
  }



  /* ==========================================================
     CHANGE / REMOVE CART LINE
  ========================================================== */

  async function changeCartLine(
    lineKey,
    quantity
  ) {

    const response = await fetch(
      SHOP_ROOT + 'cart/change.js',
      {
        method: 'POST',
        credentials: 'same-origin',

        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },

        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      }
    );


    if (!response.ok) {
      throw new Error(
        'Yukon free gift: Could not update gift quantity.'
      );
    }


    return response.json();
  }



  /* ==========================================================
     REFRESH SLEEK CART
  ========================================================== */

  function refreshCartDisplay(openDrawer) {

    /*
     * Sleek officially supports the cart:refresh event.
     *
     * open: true
     * = refresh and show the cart drawer.
     *
     * open: false
     * = refresh without forcing it open.
     */
    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true,
          detail: {
            open: openDrawer
          }
        }
      )
    );

  }



  /* ==========================================================
     CHECK WHETHER CUSTOMER IS ON /CART PAGE
  ========================================================== */

  function isCartPage() {

    const path =
      window.location.pathname.replace(
        /\/$/,
        ''
      );

    return path.endsWith('/cart');
  }



  /* ==========================================================
     UPDATE CUSTOMER-FACING CART AFTER GIFT CHANGE
  ========================================================== */

  function updateCartUI(openDrawer) {

    /*
     * On Shopify's dedicated /cart page, reload once
     * so Liquid redraws the whole cart accurately.
     *
     * There will NOT be a reload loop because after
     * reloading the gift state is already correct.
     */
    if (isCartPage()) {

      window.location.reload();
      return;

    }


    /*
     * Everywhere else use Sleek's own drawer refresh.
     */
    refreshCartDisplay(openDrawer);

  }



  /* ==========================================================
     MAIN FREE-GIFT LOGIC
  ========================================================== */

  async function synchroniseFreeGift(
    openDrawer
  ) {

    /*
     * If another synchronisation is already running,
     * remember that we need another check afterwards.
     */
    if (syncInProgress) {

      syncAgainAfterwards = true;
      return;

    }


    syncInProgress = true;


    try {

      const cart = await getCart();

      const hasHairFibres =
        cartContainsHairFibres(cart);

      const giftLines =
        getFreeGiftLines(cart);


      let cartWasChanged = false;



      /* ======================================================
         CASE 1:
         Customer has a Hair Fibre in cart.
      ====================================================== */

      if (hasHairFibres) {


        /*
         * No free applicator yet:
         * Add one.
         */
        if (giftLines.length === 0) {

          const added =
            await addFreeGift();

          if (added) {
            cartWasChanged = true;
          }

        }


        /*
         * Gift already exists:
         * Make absolutely sure quantity is ONE.
         */
        else {

          const firstGift =
            giftLines[0];


          /*
           * If quantity somehow became 2, 3, etc.,
           * reset it to 1.
           */
          if (
            Number(firstGift.quantity) !== 1
          ) {

            await changeCartLine(
              firstGift.key,
              1
            );

            cartWasChanged = true;

          }


          /*
           * Shopify can technically create separate
           * cart lines for the same variant if line
           * properties differ.
           *
           * Remove any additional free gift lines.
           */
          if (giftLines.length > 1) {

            for (
              let i = 1;
              i < giftLines.length;
              i++
            ) {

              await changeCartLine(
                giftLines[i].key,
                0
              );

            }

            cartWasChanged = true;

          }

        }

      }



      /* ======================================================
         CASE 2:
         NO Hair Fibres remain in cart.

         Remove any free promotional applicator.
      ====================================================== */

      else if (giftLines.length > 0) {

        for (
          const giftLine of giftLines
        ) {

          await changeCartLine(
            giftLine.key,
            0
          );

        }


        cartWasChanged = true;

      }



      /* ======================================================
         Refresh cart only if something actually changed.
      ====================================================== */

      if (cartWasChanged) {

        updateCartUI(
          Boolean(openDrawer)
        );

      }

    }


    catch (error) {

      console.error(
        'Yukon free gift error:',
        error
      );

    }


    finally {

      syncInProgress = false;


      /*
       * If another cart event fired while we were
       * processing, perform one final check.
       */
      if (syncAgainAfterwards) {

        syncAgainAfterwards = false;

        window.setTimeout(
          function () {

            synchroniseFreeGift(
              false
            );

          },
          100
        );

      }

    }

  }



  /* ==========================================================
     SLEEK EVENT:
     PRODUCT SUCCESSFULLY ADDED
  ========================================================== */

  document.addEventListener(
    'product-ajax:added',
    function () {

      /*
       * Wait briefly for Sleek to finish its own cart
       * operation, then add the free gift.
       *
       * openDrawer = true so the customer can actually
       * see their FREE applicator appear.
       */
      window.setTimeout(
        function () {

          synchroniseFreeGift(
            true
          );

        },
        150
      );

    }
  );



  /* ==========================================================
     SLEEK EVENT:
     CART QUANTITY / CONTENT UPDATED
  ========================================================== */

  document.addEventListener(
    'cart:updated',
    function () {

      /*
       * For example:
       * Customer removes their last Hair Fibre.
       *
       * We then remove the promotional applicator too.
       */
      window.setTimeout(
        function () {

          synchroniseFreeGift(
            !isCartPage()
          );

        },
        100
      );

    }
  );



  /* ==========================================================
     SLEEK EVENT:
     THEME HAS FULLY LOADED
  ========================================================== */

  document.addEventListener(
    'page:loaded',
    function () {

      synchroniseFreeGift(
        false
      );

    }
  );



  /* ==========================================================
     FALLBACK:
     NORMAL DOM CONTENT LOADED
  ========================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        window.setTimeout(
          function () {

            synchroniseFreeGift(
              false
            );

          },
          300
        );

      }
    );

  }

  else {

    window.setTimeout(
      function () {

        synchroniseFreeGift(
          false
        );

      },
      300
    );

  }



  /* ==========================================================
     BROWSER BACK / FORWARD CACHE SUPPORT
  ========================================================== */

  window.addEventListener(
    'pageshow',
    function (event) {

      /*
       * Useful if customer goes to checkout then presses
       * Back and the browser restores the page from cache.
       */
      if (event.persisted) {

        synchroniseFreeGift(
          false
        );

      }

    }
  );

})();